import { useMemo } from 'react';
import ForgotPasswordPage from 'Components/auth/ForgotPassword';
import LoginPage from 'Components/auth/Login';
import LLUAddConnection from 'Components/connection/AddConnection/LLUAddConnection';
// import LibreViewAddPractice from 'Components/connection/AddConnection/LibreViewAddPractice';
import LLUConnectionDetails from 'Components/connection/ConnectionDetails/LLUConnectionDetails';
import LLUPendingConnectionDetails from 'Components/connection/ConnectionDetails/LLUPendingConnectionDetails';
// import LVPendingPracticeInvitationDetails from 'Components/connection/ConnectionDetails/LVPendingPracticeInvitationDetails';
// import LVPracticeConnectionDetails from 'Components/connection/ConnectionDetails/LVPracticeConnectionDetails';
// import PartnerConnectionDetails from 'Components/connection/ConnectionDetails/PartnerConnectionDetails';
import MainConnection from 'Components/connection/MainConnection';
import InitializationErrorPage from 'Components/utility/InitializationErrorPage';
const routes = [
    { route: 'login', component: LoginPage },
    { route: 'forgot-password', component: ForgotPasswordPage },
    { route: 'connections', component: MainConnection },
    { route: 'llu-pending-connection', component: LLUPendingConnectionDetails },
    { route: 'llu-connection', component: LLUConnectionDetails },
    { route: 'llu-add-connection', component: LLUAddConnection },
    // { route: 'lv-practice-connection', component: LVPracticeConnectionDetails },
    // { route: 'lv-practice-invitation', component: LVPendingPracticeInvitationDetails },
    // { route: 'lv-add-practice', component: LibreViewAddPractice },
    // { route: 'partner-connection', component: PartnerConnectionDetails },
];
const useRouter = (location, queryString, initErrorStatus, data) => {
    const { Component, props } = useMemo(() => {
        if (initErrorStatus) {
            return {
                Component: InitializationErrorPage,
                props: { errorStatus: initErrorStatus, navigationQueryString: queryString },
            };
        }
        const lowerCaseLocation = location.toLowerCase();
        const route = routes.find((r) => lowerCaseLocation.startsWith(`/${r.route.toLowerCase()}`));
        if (route) {
            return { Component: route.component, props: { ...route.props, data } };
        }
        return { Component: LoginPage };
    }, [data, initErrorStatus, location, queryString]);
    return { Component, props };
};
export default useRouter;
